enum SupportCasePriority {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
}

export default SupportCasePriority;
